import _ from 'lodash';
import moment from 'moment';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useMount from '../../../../../../common/hooks/useMount';
import LoadingSpinner from '../../../../../../common/widgets/LoadingSpinner';
import { resources } from '../../../../resources/resources';
import { analyticsService } from '../../../../services/analytics';

export const OrdersNumberCard = () => {
  const { t: translate } = useTranslation();
  const [ordersNumber, setOrdersNumber] = useState<number | undefined>();

  const loadOrdersNumber = async (abortController?: AbortController) => {
    const resp = await analyticsService.getOrdersNumber({
      signal: abortController?.signal,
    });
    if (abortController?.signal.aborted) return;
    if (!resp.hasErrors) {
      setOrdersNumber(resp.data);
    }
  };

  useMount(loadOrdersNumber);

  return (
    <div className="mydash-budget-card">
      <div className="mydash-budget-label">
        {translate(resources.analytics.ordersNumber, {
          0: moment().year(),
        })}
      </div>
      <div className="mydash-budget-balance">
        {!_.isNil(ordersNumber) ? ordersNumber : <LoadingSpinner />}
      </div>
    </div>
  );
};
